module.exports = __webpack_public_path__ + "static/media/csv-placeholder.8db94a47.png";